import React from 'react';
import Container from '../Layout/Container';
import { Box } from '../Layout';
import { Link } from '../Typography';

const Resources = () => (
  <Container>
    <Box>
      <h1>Resources</h1>
  
 <h2>ABF4ALL Handbook</h2>
      <p>The purpose of the ABF4ALL handbook is to empower aspiring blind football coaches, allowing them
to gain a greater understanding of blind football. It will give them the skills to be able to deliver a
positive coaching experience to all players, regardless of their ability, age or sex. Whether that is
through an ABF4ALL club session or an inclusion program at other community football clubs, this
handbook is an essential tool for inclusion of people who are blind or partially sighted in football.
The creation of this handbook has been possible through a grant for our National Manager Dave
Connolly from AMP Tomorrow Fund, where Dave is a 2020 Tomorrow Maker. </p>
  <p><Link href='abf4all-handbook-standard.pdf' alt='Downlad ABF4ALL Handbook pdf' download>ABF4ALL Handbook</Link> <em>download (26mb)</em></p>
  
      <h2>Blind Football (B1) coaching manual</h2>

      <p>The IBSA Football Committee has published a coaching manual aimed at new trainers, physical education teachers and others interested in coaching blind football.</p>
      <p>The new manual targets beginners and sets out the basic principles involved in coaching players who
are blind or partially sighted skills in B1 football.</p>
      <p><Link href='http://www.ibsasport.org/news/files/1950-1-IBSA-Blind-Football-Coaching-Manual---a-guide-for-
beginners.pdf' alt='IBSA blind footbal coaching manual pdf'>IBSA blind footbal coaching manual</Link></p>

      <p>If you are interested in becoming an accredited coach in either blind football (B1) or partially sighted
futsal (B2/B3) email <Link href='mailto:football@blindsportsaustralia.com.au?Subject=Website%20Query' target='_top' aria-label='Email Blind Football Australia'>football@blindsportsaustralia.com.au</Link> to be sent a copy of the volunteer
position description and accreditation process.</p>
  
      <h2>Rules</h2>
      <p>Blind football is governed by the International Blind Sports Federation (IBSA). Links to the international rules for blind football (B1) and partially sighted/vision impaired football (B2/B3) can be found at the following link:</p>
      <p><Link href='http://www.ibsasport.org/sports/football/rules/'>http://www.ibsasport.org/sports/football/rules/</Link></p>
      <h2>Vision Impairment Classification</h2>
      <p>Paralympics Australia manages the National Classification Program for Vision Impairment. If you have a vision impairment (VI) and would like to start the process of getting a VI classification, please complete our request for classification form at <Link href='https://www.paralympic.org.au/vi-request-for-classification/'>https://www.paralympic.org.au/vi-request-for-classification/</Link></p>
      <h2>Classification Masterlist</h2>
      <p>Australian Blind Football is the recognised sporting body by Paralympics Australia for Football 5-a-side in Australia. It is a requirement to publish our national masterlist of classified athletes.</p>
      <p><Link href='PA-VI-Masterlist-5-a-side-football.pdf.pdf' alt='PA VI Masterlist 5 a side football pdf' download>PA-VA-Masterlist-5-a-side-football</Link></p>
      <h2>Videos</h2>
      <p>Want to know more about blind football, in particular the Paralympic version? If so, check out the best goals from Rio 2016:</p>
      <p><Link href='https://www.youtube.com/watch?v=o-LGBQ7mj5M'>https://www.youtube.com/watch?v=o-LGBQ7mj5M</Link></p>
    </Box>
  </Container>
);

export default Resources;



// WEBPACK FOOTER //
// ./src/Resources/Resources.js